import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRightIcon, ChevronLeftIcon } from 'lucide-react';
import { pages, getPageBySlug } from '../data/pages';
import { FormEmbed } from '../components/FormEmbed';
export function FormScreen() {
  const {
    slug = ''
  } = useParams();
  const page = getPageBySlug(slug);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [slug]);
  if (!page || !page.formEmbedUrl) return <Navigate to={`/${pages[0].slug}`} replace data-id="element-55" data-mp="3lvilxloubhwf" />;
  const index = pages.findIndex(p => p.id === page.id);
  const next = pages[index + 1];
  return <div className="w-full pb-14 pt-3 sm:pb-20 sm:pt-6" data-id="element-56" data-mp="3d0axkbhvp5s0">
      <div className="mx-auto flex w-full max-w-4xl items-center justify-between gap-4 px-4 sm:px-8" data-id="element-57" data-mp="3cyrhom04wwqr">
        <Link to={`/${page.slug}`} className="inline-flex items-center gap-1 rounded text-[12px] font-medium text-white/25 transition-colors duration-150 ease-smooth hover:text-white/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300" data-id="element-58" data-mp="3806qfc2v1neg">
          <ChevronLeftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-59" data-mp="2epi7vtgqydip" />
          Back to the video
        </Link>
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-200 sm:text-xs" data-id="element-60" data-mp="25v3jn1e8nsng">
          {page.eyebrow} form
        </p>
      </div>

      <h1 className="mx-auto mt-3 max-w-4xl px-4 text-xl font-extrabold leading-tight tracking-tight text-white sm:mt-5 sm:px-8 sm:text-3xl" data-id="element-61" data-mp="29vdzr6vqvzg1">
        {page.title}
      </h1>

      <div className="mt-4 sm:mt-6" data-id="element-62" data-mp="20wahg54ejo2l">
        <FormEmbed src={page.formEmbedUrl} title={`${page.eyebrow} onboarding form`} data-id="element-63" data-mp="20xbswapbycku" />
      </div>

      {next && <div className="mx-auto mt-6 flex w-full max-w-4xl flex-col items-center gap-2 px-4 sm:mt-8 sm:px-8" data-id="element-64" data-mp="1qxkva05h3hgj">
          <Link to={`/${next.slug}`} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-500 px-6 py-3.5 text-base font-semibold text-white transition-colors duration-150 ease-smooth hover:bg-brand-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900 sm:w-auto sm:px-8" data-id="element-65" data-mp="3h9qsfff6jp2b">
            I&apos;ve submitted this — continue
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="k3n4aca8rm3n" />
          </Link>
          <p className="text-[12px] text-white/35" data-id="element-67" data-mp="k5q6rvskz7p9">
            Only continue once you&apos;ve hit submit on the form above.
          </p>
        </div>}
    </div>;
}